const ADDON_LIST = "admin/addons/list";
const ADDON_DETAILS = "/admin/addons"

const apiUrl = {
  ADDON_LIST,
  ADDON_DETAILS,
};

export default apiUrl;
